import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { QuestionsComponents } from '../../../../core/components/questions-components';

import {
  BlueStrip,
  Button,
  Content,
  Segment,
} from './styles';

const FollowUpQuestions = (props) => {
  const {
    errorField,
    errorRetry,
    loading,
    onSubmit,
    question,
  } = props;

  const [answer, setAnswer] = useState({});

  const handleChange = (newValue) => {
    setAnswer({ value: newValue });
  };

  const label = _.isEmpty(errorRetry) ? 'Next' : 'Retry';

  // Reset state if question was changed
  useEffect(() => {
    setAnswer({});
  }, [question]);

  return (
    <Segment>
      <BlueStrip />

      <Content>
        <QuestionsComponents
          errorField={errorField}
          onChange={handleChange}
          placeholder="Type your answer"
          question={question}
          selectedValue={answer}
          typeQuestion={_.get(question, 'questionType', '')}
        />

        <Button
          disabled={loading}
          loading={loading}
          data-tester-test-proceed
          onClick={() => onSubmit(answer.value)}
        >
          {label}
        </Button>
      </Content>
    </Segment>
  );
};

FollowUpQuestions.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.string,
  }),
  errorField: PropTypes.bool,
  errorRetry: PropTypes.shape({}),
  loading: PropTypes.bool,
  onSubmit: PropTypes.func,
};

FollowUpQuestions.defaultProps = {
  errorField: false,
  errorRetry: {},
  loading: false,
  onSubmit: () => {},
  question: {},
};

export default FollowUpQuestions;
